import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { COLORS } from 'src/utils/Themes/colors'
import { useEffect, useState } from 'react'
import { CLAIM_GRAPH_TYPE_LABELS } from 'src/utils/constants/common'
import './graphStyles.css'
import CustomAxisTick from 'src/components/RiskReports/PendingClaims/CustomAxisTick'
import CustomGraphTooltip from 'src/components/RiskReports/PendingClaims/CustomGraphTooltip'
import { CLAIM_STATUS } from 'src/utils/constants/RiskReports'

const HealthPendingClaimChart = ({ data }) => {
  const [graphData, setGraphData] = useState([])

  const isValidClaim = (item) => {
    return (
      item?.claimStatus === CLAIM_STATUS?.REJECTED ||
      item?.claimStatus === CLAIM_STATUS?.OUTSTANDING ||
      item?.claimStatus === CLAIM_STATUS?.SETTLED
    )
  }

  useEffect(() => {
    createGraphData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const createGraphData = () => {
    if (data) {
      let formattedGraphData = []
      data?.forEach((item) => {
        if (isValidClaim(item)) {
          formattedGraphData.push({
            name: CLAIM_GRAPH_TYPE_LABELS?.[item?.claimStatus],
            type: item?.claimStatus,
            count: item?.count,
          })
        }
      })

      setGraphData(formattedGraphData)
    }
  }

  return (
    <>
      {graphData?.length ? (
        <ResponsiveContainer
          width='100%'
          height='100%'
          minHeight='300px'
          className={'graph'}
        >
          <BarChart width={200} height={200} data={graphData}>
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis dataKey='name' tick={<CustomAxisTick />} interval={0} />
            <YAxis />
            <Tooltip
              position={{ x: 0, y: -40 }}
              content={<CustomGraphTooltip />}
            />
            <Legend
              layout='vertical'
              margin={{ top: 0, left: 0, right: 0, bottom: 10 }}
              wrapperStyle={{
                paddingBottom: '15px',
              }}
              verticalAlign='top'
            />
            <Bar
              dataKey='count'
              name='Claim Amount'
              fill={COLORS?.BAR_CHART_COLOR1}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <p>Nil Claims</p>
      )}
    </>
  )
}

export default HealthPendingClaimChart
